'use strict';

var configure = require('./lib/configure');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return function (options) {
    options = options || {};
    return ky.post('shutdown', {
      timeout: options.timeout,
      signal: options.signal,
      headers: options.headers,
      searchParams: options.searchParams
    }).text();
  };
});